import { TaskType } from '@shared/enums/task-type.enum';

export const TaskTypeList: Array<TaskTypeItem> = [
  {
    name: 'Tasks.TaskType.task',
    type: TaskType.TYPE_TASK
  },
  {
    name: 'Tasks.TaskType.change',
    type: TaskType.TYPE_CHANGE
  },
  {
    name: 'Tasks.TaskType.order',
    type: TaskType.TYPE_ORDER
  },
  {
    name: 'Tasks.TaskType.follow_up',
    type: TaskType.TYPE_FOLLOW_UP
  },
  {
    name: 'Tasks.TaskType.appointment',
    type: TaskType.TYPE_APPOINTMENT
  },
  {
    name: 'Tasks.TaskType.correction',
    type: TaskType.TYPE_CORRECTION
  }
];

export interface TaskTypeItem {
  name: string;
  type: TaskType;
}
